















import Vue from 'vue'
import ReportingTree  from '../components/reporting/ReportingTree.vue'
import ReportingFilter  from '../components/reporting/ReportingFilter.vue'
import { ReportFilterItem } from '@/types/service-response';
import { COMPANY_FETCH_COMPANY_STRUCTURE } from '@/store/action-types'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE } from '@/store/getter-types'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'

interface ComponentData {
  reportItem: Array<ReportFilterItem>
  componentKey: number
  reportLayout: string
  reportName: string
  planningGroupList: PlanningGroup[]
}

export default Vue.extend({
  name: 'ReportingPage',

  components: {
    ReportingTree,
    ReportingFilter
  },

  data (): ComponentData {
    return {
      reportItem: [],
      componentKey: 0,
      reportLayout: '',
      reportName: '',
      planningGroupList: []
    }
  },
  computed: {
    selectedClass (): number {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 3
      } else {
        return 1
      }
    }
  },

  methods: {
    selectedReport(payload: {reportItem: Array<ReportFilterItem>, reportLayout: string, reportName: string}): void {
      this.reportItem = payload.reportItem
      this.reportLayout = payload.reportLayout
      this.reportName = payload.reportName
      this.componentKey += 1
    },

    async fetchEmployeeList (): Promise<void> {
      await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
       this.planningGroupList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).planningGroupList
    }
  },

  mounted (): void {
    this.fetchEmployeeList()
  }
    
})
